export const FETCH_RN_PENDING_REPORT_REQUEST_DK = 'FETCH_RN_PENDING_REPORT_REQUEST_DK';
export const FETCH_RN_PENDING_REPORT_SUCCESS_DK = 'FETCH_RN_PENDING_REPORT_SUCCESS_DK';
export const FETCH_RN_PENDING_REPORT_FAILURE_DK = 'FETCH_RN_PENDING_REPORT_FAILURE_DK';

export const FETCH_RN_PENDING_REPORTS_STYLE_WISE_REQUEST = 'FETCH_RN_PENDING_REPORTS_STYLE_WISE_REQUEST';
export const FETCH_RN_PENDING_REPORTS_STYLE_WISE_SUCCESS = 'FETCH_RN_PENDING_REPORTS_STYLE_WISE_SUCCESS';
export const FETCH_RN_PENDING_REPORTS_STYLE_WISE_FAILURE = 'FETCH_RN_PENDING_REPORTS_STYLE_WISE_FAILURE';

export const FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_REQUEST = 'FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_REQUEST';
export const FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_SUCCESS = 'FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_SUCCESS';
export const FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_FAILURE = 'FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_FAILURE';


export const FETCH_RN_IN_STOCK_REPORTS_REQUEST = 'FETCH_RN_IN_STOCK_REPORTS_REQUEST';
export const FETCH_RN_IN_STOCK_REPORTS_SUCCESS = 'FETCH_RN_IN_STOCK_REPORTS_SUCCESS';
export const FETCH_RN_IN_STOCK_REPORTS_FAILURE = 'FETCH_RN_IN_STOCK_REPORTS_FAILURE';
